import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/core/services/common.service";
import { PermissionService } from "src/app/core/services/permisson.service";
import { TdspCommonService } from "src/app/core/services/tdsp/tdsp-common.service";
import { TdspConversionPixelService } from "src/app/core/services/tdsp/tdsp-conversion-pixel.service";
import { tdspConversionPixel } from "src/app/models/tdsp/tdsp-conversion-pixel";

@Component({
  selector: "app-tdsp-edit-conversion-pixel",
  templateUrl: "./tdsp-edit-conversion-pixel.component.html",
  styleUrl: "./tdsp-edit-conversion-pixel.component.scss",
})
export class TdspEditConversionPixelComponent {
  activeStep: string;
  globalParams: Object = {};

  conversionPixel: tdspConversionPixel;
  pixelId: number;

  constructor(
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private tdspCommonService: TdspCommonService,
    private tdspConversionPixelService: TdspConversionPixelService,
    public permissionService: PermissionService
  ) {
    this.conversionPixel = {
      name: "",
      dynamic_parameters: [],
      containsParam: false,
    };
  }

  ngOnInit() {
    let params = this.commonService.getObjfromParams(
      this.activatedRoute.snapshot.queryParamMap
    );
    this.globalParams = this.commonService.getclientID(params);
    this.pixelId = parseInt(this.activatedRoute.snapshot.paramMap.get("id"));
    this.retrievePixel();
  }

  retrievePixel() {
    this.tdspConversionPixelService
      .getById(this.pixelId, this.globalParams)
      .subscribe(
        (res) => {
          this.conversionPixel = res;
          this.conversionPixel.containsParam =
            Array.isArray(res.dynamic_parameters) &&
            res.dynamic_parameters.length > 0;
        },
        (err) => {},
        () => {
          this.activeStep = this.commonService.sideNavStepChange(
            "basic_step",
            "tdspConversionPixel",
            "Conversion Pixel"
          );
          this.commonService.sideMenuStatus(
            [{ id: "basic_step", status: true }],
            "tdspConversionPixel"
          );
        }
      );
  }

  basicStepChange(event) {
    this.tdspCommonService.preparePayloadAndSubmitConversionPixel(
      event,
      "update",
      this.globalParams,
      this.pixelId
    );
  }
}
